import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ErrorBoundary } from './providers/ErrorBoundary';
import { QueryProvider } from './providers/QueryProvider';
import { router } from './router/routes';

const App = () => (
  <ErrorBoundary>
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors closeButton toastOptions={{ duration: 4000 }} />
    </QueryProvider>
  </ErrorBoundary>
);

export default App;
